var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61.251,
    viewBox: "0 0 61 61.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px;}.b{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -0.749)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.9,41c-3.3-1-3.9-2.9-3.9-4V35a14.1,14.1,0,0,0,4-7c2.5,0,4-3,4-6,0-.8,0-4-2-4C43,3.5,28.4-2,18,5c-4.4,0-5.6,6.6-4,13-2,0-2,3.2-2,4,0,3,1.5,6,4,6a14.2,14.2,0,0,0,4,7v2c0,1.6-.5,3.6-8.6,5.2A11.665,11.665,0,0,0,2,51H34.3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(34 34)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 14,
    cy: 14,
    r: 13
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42,48H54m-6,6V42"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUser);
export default __webpack_public_path__ + "static/media/new-user.0001bb4837c17719c6eb0976e45fbcf8.svg";
export { ForwardRef as ReactComponent };